import { graphql } from "@opensea/graphql"
import {
  useCurrencyBannerMediaFallbackFragment,
  useCurrencyBannerMediaFragment,
} from "../use-currency-banner-media"

export const CurrencyBannerMediaFragment = graphql(
  `
    fragment CurrencyBannerMedia on Currency {
      ...useCurrencyBannerMedia
      ...useCurrencyBannerMediaFallback
    }
  `,
  [useCurrencyBannerMediaFragment, useCurrencyBannerMediaFallbackFragment],
)
